module.exports = __webpack_public_path__ + "static/media/slide4.debe5321.jpg";